import React from 'react';
import "./Loading.scss"

const Loading = () => {
    return (
        <div className="Loading">
            <div className="Loading__inner_one"></div>
            <div className="Loading__inner_two"></div>
            <div className="Loading__inner_three"></div>
        </div>
    );
};

export default Loading;